import { transformLineItemToBE } from '../transformLineItemToBE'

import { UNITS } from '../../fields'

export const formatQuantitySingleAllocationLineItem = ({ inventory, values, right, campaignId, currency }) => {
  const units = values[UNITS]
  // In single allocation right all inventory items have the same price, so we can take the price from the first inventory item
  const microAmount = inventory[0].prices[right.billing_event] || 0

  return transformLineItemToBE({
    inventory,
    values,
    campaignId,
    units,
    microAmount,
    right,
    currency
  })
}
